const url = window.location.hostname;
var portData = window.location.port;
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_TOKEN,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MICROSOFT_TENANT_TOKEN}/`,
    redirectUri: window.location.protocol+"//" + url + ":" + portData + '/',
    scopes : "api://{client_id}/.default"
  },
  cache: {
    cacheLocation: 'sessionStorage', // or 'localStorage'
    storeAuthStateInCookie: false,
  },
};
